// extracted by mini-css-extract-plugin
export default {"note":"note--_uSAX"};